import React from 'react';
// import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { AiFillHtml5 } from 'react-icons/ai';
import { DiCss3 } from 'react-icons/di';
import { IoLogoJavascript } from 'react-icons/io';
import { FaReact } from 'react-icons/fa';
import { SiMongodb } from 'react-icons/si';
import { FaNodeJs } from 'react-icons/fa';
import { SiExpress } from 'react-icons/si';
import { FaBootstrap } from 'react-icons/fa';
import { SiTailwindcss } from 'react-icons/si';
import { AiFillGithub } from 'react-icons/ai';
import { FiFigma } from 'react-icons/fi';


const Skills = () => {

    const skills = [
        {
            id: 1,
            icon: <AiFillHtml5></AiFillHtml5>,
            name: 'Html'
        },
        {
            id: 2,
            icon: <DiCss3></DiCss3>,
            name: 'CSS'
        },
        {
            id: 3,
            icon: <IoLogoJavascript></IoLogoJavascript>,
            name: 'JavaScript'
        },
        {
            id: 4,
            icon: <FaReact></FaReact>,
            name: 'React'
        },
        {
            id: 5,
            icon: <SiMongodb></SiMongodb>,
            name: 'MongoDB'
        },
        {
            id: 6,
            icon: <FaNodeJs></FaNodeJs>,
            name: 'Node.js'
        },
        {
            id: 7,
            icon: <SiExpress></SiExpress>,
            name: 'Express.js'
        },
        {
            id: 8,
            icon: <FaBootstrap></FaBootstrap>,
            name: 'Bootstrap'
        },
        {
            id: 9,
            icon: <SiTailwindcss></SiTailwindcss>,
            name: 'Tailwind'
        },
        {
            id: 10,
            icon: <AiFillGithub></AiFillGithub>,
            name: 'GitHub'
        },
        {
            id: 11,
            icon: <FiFigma></FiFigma>,
            name: 'Figma'
        },
    ]

    
    return (
        <div id='skills'>
            <div className='p-5 md:p-10 md:m-24 skills'>
                <h1 className='list text-start md:text-center'>LIST OF SKILLS</h1>
                <p className=' md:w-3/5 mx-auto skill-intro text-start md:text-center'>I learned the following skills for almost 1 years and continued practicing. I am working on developing my skills day by day and exploring many new things. Hope to add more new skills.</p>
                <div className='grid grid-cols-3 gap-x-3 md:gap-x-0 md:grid-cols-2 lg:grid-cols-6 mb-6 '>
                    {
                        skills.map(skill => <div key={skill.id} className='flex flex-col justify-center items-center'  data-aos="zoom-in-right">
                            <h1 className='icon mt-10'>{skill.icon}</h1>
                            <p className='skill font-medium'>{skill.name}</p>
                        </div>)
                    }
                </div>
            </div>
            {/* <div>
                <RadarChart
                    cx={300}
                    cy={250}
                    outerRadius={150}
                    width={500}
                    height={500}
                    data={data}
                >
                    <PolarGrid />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis />
                    <Radar
                        name="Skills"
                        dataKey="A"
                        stroke="#ffd372"
                        fill="#ffd372"
                        fillOpacity={0.6}
                    />
                </RadarChart>
            </div> */}
        </div>
    );
};

export default Skills;